import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bb1987ce&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bb1987ce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1987ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb1987ce')) {
      api.createRecord('bb1987ce', component.options)
    } else {
      api.reload('bb1987ce', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bb1987ce&scoped=true", function () {
      api.rerender('bb1987ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P5_Activitys/RechargeAfterFirst/index.vue"
export default component.exports